import React from "react";
import {
  Autocomplete as AutocompleteMUI,
  Box,
  Stack,
  TextField,
} from "@mui/material";

import { countries } from "../utils/countries";

type Country = {
  label: string;
  code: string;
  phone: string;
};

const Autocomplete = () => {
  const filterOptions = (
    options: Country[],
    { inputValue }: { inputValue: string },
  ) => {
    return options.filter((option) => {
      const searchTerm = inputValue.toLowerCase();

      return (
        option.label.toLowerCase().includes(searchTerm) ||
        option.code.toLowerCase().includes(searchTerm) ||
        option.phone.includes(searchTerm)
      );
    });
  };

  return (
    <Stack spacing={2}>
      <AutocompleteMUI
        options={countries}
        autoHighlight
        getOptionLabel={(option) => option.label}
        filterOptions={filterOptions}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...optionProps}
            >
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              {option.label} ({option.code}) +{option.phone}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} label="Choose a country" />
        )}
      />

      <AutocompleteMUI
        options={countries}
        autoHighlight
        getOptionLabel={(option) => option.label}
        filterOptions={filterOptions}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ display: "flex", alignItems: "center", mb: 1 }}
              {...optionProps}
            >
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              <Box sx={{ ml: 2 }}>
                <Box sx={{ fontWeight: "bold" }}>{option.label}</Box>
                <Box sx={{ fontSize: "0.875rem", color: "text.secondary" }}>
                  {option.code} +{option.phone}
                </Box>
              </Box>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} label="Choose a country" />
        )}
      />

      <AutocompleteMUI
        multiple
        options={countries}
        autoHighlight
        getOptionLabel={(option) => option.label}
        filterOptions={filterOptions}
        defaultValue={[countries[99]]}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...optionProps}
            >
              <img
                loading="lazy"
                width="20"
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                alt=""
              />
              {option.label} ({option.code}) +{option.phone}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} label="Choose a country" />
        )}
      />
    </Stack>
  );
};

export default Autocomplete;
